import { lazy, useEffect } from 'react';
import { useDialog } from './DialogProvider';

const SettingsDialog = lazy(async () => {
  const module = await import('../components/settings/SettingsDialog.web');
  return { default: module.SettingsDialog };
});

export const useSettingsModal = () => {
  const { open } = useDialog();
  return { open: () => open('settings') };
};

/** Registers the settings dialog once: wrap inside DialogProvider. */
export function SettingsModalProvider({ children }: { children: React.ReactNode }) {
  const { register } = useDialog();

  useEffect(() => {
    register('settings', SettingsDialog);
  }, [register]);

  return <>{children}</>;
}
